/**
 * Склонение существительного после числа: 1 событие, 3 события, 5 событий.
 * forms — [одно, два–четыре, пять и больше]. См. docs/STYLE_GUIDE.md.
 */
export const pluralRu = (count, forms) => {
  const abs = Math.abs(Math.trunc(Number(count) || 0));
  const mod10 = abs % 10;
  const mod100 = abs % 100;
  if (mod10 === 1 && mod100 !== 11) return forms[0];
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 10 || mod100 >= 20)) return forms[1];
  return forms[2];
};

/** «5 событий» — число вместе со словом. */
export const countRu = (count, forms) => `${count} ${pluralRu(count, forms)}`;

export const EVENT_FORMS = ['событие', 'события', 'событий'];
export const VIOLATION_FORMS = ['нарушение', 'нарушения', 'нарушений'];
export const OBJECT_FORMS = ['объект', 'объекта', 'объектов'];
export const CAMERA_FORMS = ['камера', 'камеры', 'камер'];
export const ZONE_FORMS = ['зона', 'зоны', 'зон'];
export const ATTEMPT_FORMS = ['попытка', 'попытки', 'попыток'];
export const POINT_FORMS = ['точка', 'точки', 'точек'];
export const SECOND_FORMS = ['секунда', 'секунды', 'секунд'];
export const MINUTE_FORMS = ['минута', 'минуты', 'минут'];
export const HOUR_FORMS = ['час', 'часа', 'часов'];
export const DAY_FORMS = ['день', 'дня', 'дней'];
export const LINKED_EVENT_FORMS = ['связанное событие', 'связанных события', 'связанных событий'];
export const PAIR_FORMS = ['пара', 'пары', 'пар'];
export const USER_FORMS = ['пользователь', 'пользователя', 'пользователей'];
export const RULE_FORMS = ['правило', 'правила', 'правил'];
export const FRAME_FORMS = ['кадр', 'кадра', 'кадров'];
